enum CountryBillingType {
  Argentina = 1,
  Brasil = 2,
  Chile = 3,
  Peru = 4,
}

export default CountryBillingType;
